<wj-tab-panel id="tab_SearchResult" #tab_SearchResult [tabindex]="-1" [isAnimated]="false">
  <wj-tab>
    <a id="a_Product" #a_Product>商品画像</a>
    <div class="frame-solid">
      <div class="layout_end head-count-container">
        <div>
          <label id="lbl_GoodsImageCnt"
            [style.margin-right.px]="4">{{goodsImageCnt}}</label>
          <label [style.margin-right.px]="2">件</label>
        </div>
      </div>

      <div id="hli_GoodsImageList" #hli_GoodsImageList class="frame-solid">
        <ul #goodsImageGroups>
          <li *ngFor="let item of goodsImageList; let i = index;"
            (mousedown)="eventGoodsImageList_ITEMCLICK.emit({event: $event, index: i, goodsImageList: goodsImageList, goodsImageGroups: goodsImageGroups})">
            <app-image-info-renderer1407 [data]="item"></app-image-info-renderer1407>
          </li>
        </ul>
      </div>
    </div>
  </wj-tab>
  <wj-tab>
    <a id="a_History" #a_History>使用履歴</a>
    <div class="frame-solid">
      <div class="layout_balance head-count-container">
        <div class="column-list">
          <label class="list-input-title">Ｐコード</label>
          <div class="list-input-content">
            <select id="cmb_PcodeList"
              forcedEnabledMode="true" [tabindex]="-1" [(ngModel)]="pCode"
              (change)="eventPcodeList_CHANGE.emit($event)">
              <ng-template ngFor let-item [ngForOf]="pcodeList">
                <option value="{{item.Pcode}}">{{item.Pcode}}</option>
              </ng-template>
            </select>
          </div>
        </div>

        <div>
          <label id="lbl_UseHitoryImageCnt"
            [style.margin-right.px]="4">{{useHitoryImageCnt}}</label>
          <label [style.margin-right.px]="2">件</label>
        </div>
      </div>

      <div class="block-row history-container">
        <wj-flex-grid id="dgv_PcodeInfoList" #dgv_PcodeInfoList [itemsSource]="pcodeInfoList"
          [isReadOnly]="true" [allowResizing]="true"
          [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'" [tabindex]="-1" class="always-scrollbars">
          <wj-flex-grid-column [minWidth]="5" [header]="'受注コード'" [binding]="'OrderCode'" [width]="95">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'配達企画回(翌週)'" [binding]="'DelivCatalogId'" [width]="130">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'媒体'" [binding]="'MediumName'" [width]="162">
          </wj-flex-grid-column>
        </wj-flex-grid>

        <div id="hli_UseHistoryImageList" #hli_UseHistoryImageList class="frame-solid"
          forcedEnabledMode="true">
          <ul #useHistoryImageGroups>
            <li *ngFor="let item of useHistoryImageList; let i = index;"
              (mousedown)="eventUseHistoryImageList_ITEMCLICK.emit({event: $event, index: i, useHistoryImageList: useHistoryImageList, useHistoryImageGroups: useHistoryImageGroups})">
              <app-image-info-renderer1407 [data]="item"></app-image-info-renderer1407>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </wj-tab>
  <wj-tab>
    <a id="a_Search" #a_Search>検索画像</a>
    <div class="frame-solid element-column">
      <div class="layout_balance head-count-container">
        <div>
          <button id="btn_Search" forcedEnabledMode="true" [tabindex]="-1"
            class="btn-secondary" style="min-width:70px;"
            (click)="eventBtnSearch_CLICK.emit()">画像検索</button>
        </div>
        <div>
          <label id="lbl_SearchImageCnt" [style.margin-right.px]="4">{{searchImageCnt}}</label>
          <label [style.margin-right.px]="2">件</label>
        </div>
      </div>
      <div id="hli_SearchImageList" #hli_SearchImageList class="frame-solid"
        forcedEnabledMode="true">
        <ul #searchImageGroups>
          <li *ngFor="let item of searchImageList; let i = index;"
            (mousedown)="eventSearchImageList_ITEMCLICK.emit({event: $event, index: i, searchImageList: searchImageList, searchImageGroups: searchImageGroups})">
            <app-image-info-renderer1407 [data]="item"></app-image-info-renderer1407>
          </li>
        </ul>
      </div>
    </div>
  </wj-tab>
</wj-tab-panel>
